import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Typography } from '@mui/material';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    required: boolean;
    onChange: (value: any) => void;
    idQuestion?: string;
    questionType?: string;
    value?: string;
    disabled?: boolean;
};

const FieldOpenTextAnswer = ({
    title,
    required,
    onChange,
    idQuestion,
    questionType,
    value,
    disabled,
}: Props) => {
    const formik = useFormik({
        initialValues: {
            idQuestion,
            answer: value || '',
            type: questionType,
        },
        validationSchema: Yup.object({
            answer: required
                ? Yup.string()
                    .required('El comentario es obligatorio')
                    .max(2000, 'Máximo 2000 caracteres')
                : Yup.string().max(2000, 'Máximo 2000 caracteres'),
        }),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit: () => {},
    });

    useEffect(() => {
        const answer =
            value !== undefined && value !== null
                ? String(value)
                : formik.values.answer;
        onChange({
            ...formik.values,
            answer,
            error:
                (required && !answer.trim()) ||
                (answer === formik.values.answer &&
                    Boolean(formik.errors.answer)),
        });
    }, [formik.values, formik.errors.answer, required, value]);

    return (
        <>
            <LabelAnswer text={title} isRequired={required} />
            <br />
            <FieldTextAreaAutoSize
                name="answer"
                touched={Boolean(formik.errors.answer)}
                errors={formik.errors.answer}
                placeholder="Escribe aquí tus comentarios sobre la atención recibida..."
                required={required}
                onChange={formik.handleChange}
                type="big-text"
                value={value}
                disabled={disabled}
            />
            {formik.values.answer && (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}
                >
                    {formik.values.answer.length}/2000
                </Typography>
            )}
        </>
    );
};

export default FieldOpenTextAnswer;
